import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  const { width = "48px", height, color, spin, theme, style, ...rest } = props;
  return (
    <img
      src="/images/logo_white_bg.png"
      alt="Machain"
      width={width}
      height={height ?? width}
      style={{ objectFit: "contain", display: "block", ...style }}
      {...rest}
    />
  );
};

export default Icon;
